import React from 'react'
import JobsScreen from '../Components/Jobs/JobsScreen'
// import JobsMap from '../Components/Jobs/JobsMap'
import JobsBanner from '../Components/Jobs/JobsBanner'

const ContactUs = () => {
    return (
        <>
            <JobsBanner />
            <JobsScreen />
            {/* <JobsMap /> */}
        </>
    )
}

export default ContactUs